import { render, staticRenderFns } from "./ref-index.vue?vue&type=template&id=c48b97dc&scoped=true&"
import script from "./ref-index.vue?vue&type=script&lang=js&"
export * from "./ref-index.vue?vue&type=script&lang=js&"
import style0 from "./ref-index.vue?vue&type=style&index=0&id=c48b97dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48b97dc",
  null
  
)

export default component.exports